import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { PeriodCostRow, PeriodCostLabel, PeriodCostValue } from './styled';

interface PeriodCostSummaryProps {
  cost: number;
}

const PeriodCostSummary: React.FC<PeriodCostSummaryProps> = ({ cost }) => {
  const { t } = useTranslation('payment-and-invoices');

  return (
    <PeriodCostRow>
      <PeriodCostLabel>{t('period_consumption')}</PeriodCostLabel>
      <PeriodCostValue>&euro;{cost.toFixed(2)}</PeriodCostValue>
    </PeriodCostRow>
  );
};

export default PeriodCostSummary;
